<template>
  <div>
    <div class="r-text-intro">פרטים אישיים | ת.ז. רגילה</div>
    <div class="r-text-headline">העלאת תעודה וספח ביחד</div>
    <social-id-part-uploader
      :social-id-upload-url="socialIdUploadUrl"
      :social-id-files="socialIdFiles"
      part-name="main"
      part-name-hebrew="תעודת זהות"
      preload-success-text="הועלתה בהצלחה!"
      @observe="observe"
      v-on="$listeners" />
  </div>

</template>

<script>
import SocialIdPartUploader from '@/components/SocialIdPartUploader';
import ValidationObserver from '@/mixins/ValidationObserver';

export default {
  name: 'UploadSimpleId',
  components: { SocialIdPartUploader },
  mixins: [ValidationObserver],
  props: {
    socialIdUploadUrl: {
      type: String,
      required: true,
    },
    socialIdFiles: Object,
  },
  methods: {
    socialIdPartUploaded(partName, fileVersion) {
      this.$emit('uploaded', { partName, fileVersion });
    },
    socialIdPartRemove(partName) {
      this.$emit('removed', { partName });
    },
  },
};
</script>

<style lang="scss" scoped>
.r-text-headline {
  margin-bottom: 13px;
}
</style>
